"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupActivityStatus = groupActivityStatus;
exports.groupBuyDelete = groupBuyDelete;
exports.groupBuyInfo = groupBuyInfo;
exports.groupBuyList = groupBuyList;
exports.groupBuyListCount = groupBuyListCount;
exports.groupBuyRecordCount = groupBuyRecordCount;
exports.groupBuyRecordList = groupBuyRecordList;
exports.groupBuySave = groupBuySave;
exports.groupBuyUpdate = groupBuyUpdate;
exports.groupRecordInfo = groupRecordInfo;
exports.groupbuyActivityRollback = groupbuyActivityRollback;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

// ------------------------拼团活动----------------------------------------

/**
 * 新增
 * @param
 */
function groupBuySave(pram) {
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/save',
    method: 'POST',
    data: pram
  });
}

/**
 * 分页列表
 * @param
 */
function groupBuyList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit,
    groupName: pram.groupName,
    groupProcess: pram.groupProcess,
    activityStatus: pram.activityStatus,
    groupStatus: pram.groupStatus,
    startTime: pram.startTime
  };
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/list',
    method: 'get',
    params: data
  });
}
/**
 * 修改
 * @param
 */
function groupBuyUpdate(pram) {
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/update',
    method: 'post',
    data: pram
  });
}
/**
 * 删除
 * @param
 */
function groupBuyDelete(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/delete',
    method: 'get',
    params: data
  });
}
/**
 * 详情
 * @param
 */
function groupBuyInfo(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: "/admin/merchant/groupbuy/activity/info",
    method: 'get',
    params: data
  });
}
/**
 * 拼团头部
 * @param
 */
function groupBuyListCount(data) {
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/list/count',
    method: 'get',
    params: data
  });
}
/**
 * 状态变更
 * @param
 */
function groupActivityStatus(pram) {
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/status',
    method: 'post',
    data: pram
  });
}
/**
 * 撤回审核
 * @param
 */
function groupbuyActivityRollback(id) {
  var data = {
    id: id
  };
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/activity/activity/rollback',
    method: 'get',
    params: data
  });
}
// ------------------------拼团记录----------------------------------------
/**
 * 分页列表
 * @param
 */
function groupBuyRecordList(data) {
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/record/list',
    method: 'get',
    params: data
  });
}
/**
 * 详情
 * @param
 */
function groupRecordInfo(id) {
  return (0, _request.default)({
    url: "/admin/merchant/groupbuy/record/info/".concat(id),
    method: 'get'
  });
}
/**
 * 头部
 * @param
 */
function groupBuyRecordCount(data) {
  return (0, _request.default)({
    url: '/admin/merchant/groupbuy/record/list/count',
    method: 'get',
    params: data
  });
}